module.exports = __webpack_public_path__ + "static/media/fa-solid-900.b5cf8ae2.woff2";